// eslint-disable-next-line
<template>
  <div>
    <div class="container" style="min-height:100vh;">
      <ux-image-grid-view-a
        v-if="uploads && ready"
        :sections="true"
        :items="uploads"
        keyTitle="name"
      />
    </div>
  </div>
</template>

<script>
import UxImageGridViewA from "./UxImageGridViewA";
export default {
  components: { UxImageGridViewA },
  data() {
    return {
      ready: false,
      currentTag: ""
    };
  },
  created() {
    if (!this.$store.getters.uploads.length) {
      this.$store.dispatch("fetchUploads").then(() => {
        this.$store.dispatch("fetchTags").then(() => {
          this.ready = true;
        });
      });
    }
    this.ready = true;
  },
  methods: {
    updateTag(tag) {
      this.currentTag = tag;
    }
  },
  filters: {
    title(val) {
      if (!val) return "";
      val = val.toString();
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
  },
  computed: {
    uploads() {
      return this.$store.getters.uploads;
      // if (this.currentTag) {
      //   return this.$store.getters.uploads.filter(el => {
      //     return el.tags.includes(this.currentTag);
      //   });
      // }
      // return _.shuffle(this.$store.getters.filteredUploads);
    },
    tags() {
      return this.$store.getters.filteredTags;
    }
  }
};
</script>

<style lang="scss" scoped>
.page-heading {
  margin-bottom: 30px;
}
</style>
